"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
var _Adresse = _interopRequireDefault(require("../model/Adresse"));
var _AdresseCreate = _interopRequireDefault(require("../model/AdresseCreate"));
var _HTTPValidationError = _interopRequireDefault(require("../model/HTTPValidationError"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * KFV LDS API
 * Die KFV LDS API bietet eine Schnittstelle zum Backend der PWA.
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

/**
* Adresse service.
* @module api/AdresseApi
* @version 0.0.1
*/
class AdresseApi {
  /**
  * Constructs a new AdresseApi. 
  * @alias module:api/AdresseApi
  * @class
  * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
  * default to {@link module:ApiClient#instance} if unspecified.
  */
  constructor(apiClient) {
    this.apiClient = apiClient || _ApiClient.default.instance;
  }

  /**
   * Callback function to receive the result of the createAdresseAdressePost operation.
   * @callback module:api/AdresseApi~createAdresseAdressePostCallback
   * @param {String} error Error message, if any.
   * @param {module:model/Adresse} data The data returned by the service call.
   * @param {String} response The complete HTTP response.
   */

  /**
   * Create Adresse
   * @param {module:model/AdresseCreate} adresseCreate 
   * @param {module:api/AdresseApi~createAdresseAdressePostCallback} callback The callback function, accepting three arguments: error, data, response
   * data is of type: {@link module:model/Adresse}
   */
  createAdresseAdressePost(adresseCreate, callback) {
    let postBody = adresseCreate;
    // verify the required parameter 'adresseCreate' is set
    if (adresseCreate === undefined || adresseCreate === null) {
      throw new Error("Missing the required parameter 'adresseCreate' when calling createAdresseAdressePost");
    }
    let pathParams = {};
    let queryParams = {};
    let headerParams = {};
    let formParams = {};
    let authNames = ['JWTBearer'];
    let contentTypes = ['application/json'];
    let accepts = ['application/json'];
    let returnType = _Adresse.default;
    return this.apiClient.callApi('/adresse/', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
  }
}
exports.default = AdresseApi;